import { WidgetEmptyState } from './WidgetEmptyState'

export default WidgetEmptyState
